import(/* webpackMode: "eager" */ "/var/www/higuard/frontend/src/app/layout.tsx");
